import Button from '__components/Button';
import useModal from '__components/Modals/useModal';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { generateCSV } from 'pages/SmartConnectors/SmartConnector/helpers';
import { type GenericOption } from 'pages/SmartConnectors/types';
import { CreateBulkactionModal } from './CreateBulkactionModal';

type CreateBulkActionButtonProps = {
  fileInputRef: React.RefObject<HTMLInputElement>;
};

// format: bulkaction-sample-YYYY-MM-DD_hh-mm-ss.csv
const getCSVFileName = () =>
  `bulkaction-sample-${new Date()
    .toLocaleDateString('en')
    .split('/')
    .join(
      '-'
    )}_${new Date().toLocaleTimeString('en', { hour12: false }).split(':').join('-')}.csv`;

export const CreateBulkActionButton: FC<CreateBulkActionButtonProps> = ({
  fileInputRef,
}) => {
  const { t } = useTranslation();

  const [modalProps, { onClick }] = useModal({
    handleSubmit: (fields: GenericOption[]) => {
      if (fileInputRef.current) {
        const csvText = generateCSV([
          ['kizen_id'],
          ...fields.map((field) => [field.value]),
        ]);

        const dataTransfer = new DataTransfer();
        const file = new File(
          [new Blob([csvText], { type: 'text/csv;charset=utf-8' })],
          getCSVFileName()
        );
        dataTransfer.items.add(file);

        fileInputRef.current.focus();
        fileInputRef.current.files = dataTransfer.files;
        fileInputRef.current.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        fileInputRef.current.blur();
      }
    },
  });

  return (
    <>
      <Button variant="outline" color="blue" onClick={onClick}>
        {t('Generate Sample File')}
      </Button>
      {modalProps.show ? <CreateBulkactionModal {...modalProps} /> : null}
    </>
  );
};
